module.exports = __webpack_public_path__ + "img/imgpsh_fullsize.a4a38e1f.jpg";